class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('[id^="ModalClose-"]').forEach((item) => {
      item.addEventListener("click", this.hide.bind(this));
    });
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  clearErrors() {
    const errorElementSelector = this.querySelector(
      this.getAttribute("data-error-selector")
    );
    if (errorElementSelector) {
      errorElementSelector.setAttribute("hidden", true);
    }
  }

  hide(removeOverflow = true) {
    const openedModals = document.querySelectorAll("modal-dialog[open]");
    if (openedModals.length >= 1 && removeOverflow) {
      document.body.classList.remove("overflow-hidden");
    }
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    this.clearErrors();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector("[data-cta-modal]");
    this.modal = document.querySelector(this.getAttribute("data-modal"));
    if (!this.button) return;
    if (this.dataset.targetUrl) {
      this.targetUrl = this.dataset.targetUrl;
    }
    if (this.dataset.targetElement) {
      this.targetElement = this.dataset.targetElement;
    }
    if (this.button)
      this.button.addEventListener("click", async (e) => {
        await this.LoadAndOpenModal(e);
      });
  }
  async LoadAndOpenModal(evt = null) {
    if (evt) evt.preventDefault();
    if (this.button.hasAttribute("data-upsell-modal")) {
      await this.appendCartUpsell();
    }
    this.modal = document.querySelector(this.getAttribute("data-modal"));
    if (this.targetUrl && this.targetElement) {
      window.loaders = window.loaders || {};
      this.currentUrl = this.targetUrl;
      if (this.dataset.subPath) {
        this.currentUrl = this.targetUrl + this.dataset.subPath;
      }
      if (!window.loaders[this.currentUrl]) {
        await this.fetchSectionData();
      }
      const html = await window.loaders[this.currentUrl];
      if (!html) return;
      this.renderData(html);
    }
    if (this.modal) {
      this.modal.show();
    }
  }
  fetchCartUpsell() {
    return new Promise(async (resolve) => {
      const resText = await apiFetchText(
        "",
        "?section_id=upsell-modal-container"
      );
      const upsellWrapper = document.getElementById(
        "Cart-upsell-modal-container"
      );
      if (upsellWrapper) {
        upsellWrapper.innerHTML = resText;
      }
      resolve(resText);
    });
  }

  async appendCartUpsell() {
    this.modal = document.querySelector(this.getAttribute("data-modal"));
    if (!window.cartUpsell) {
      showLoader();
      window.cartUpsell = await this.fetchCartUpsell();
      showLoader(false);
      return;
    }
    const upsellWrapper = document.getElementById(
      "Cart-upsell-modal-container"
    );
    if (upsellWrapper) {
      upsellWrapper.innerHTML = window.cartUpsell;
    }
  }

  renderData(html) {
    const content = html.querySelector(`${this.targetElement}`);
    if (this.dataset.contentId) {
      document.querySelector(this.dataset.contentId).innerHTML =
        content.innerHTML;
    } else {
      this.modal.innerHTML = content.innerHTML;
    }
  }

  async fetchSectionData() {
    showLoader();
    window.loaders[this.currentUrl] = new Promise(async (resolve) => {
      const res = await apiFetchText(this.currentUrl, "");
      const html = new DOMParser().parseFromString(res, "text/html");
      showLoader(false);
      resolve(html);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class ConfirmModal extends HTMLElement {
  constructor() {
    super();
    this.confirmButton = this.querySelector(".confirm-btn");
    this.cancelButtons = this.querySelectorAll(".cancel-btn");
  }
  show() {
    let _this = this;
    document.body.classList.add("overflow-hidden");
    _this.setAttribute("open", "true");
    return new Promise((resolve) => {
      this.confirmButton.focus();
      this.confirmButton.addEventListener("click", () => {
        _this.removeAttribute("open");
        resolve(true);
        document.body.classList.remove("overflow-hidden");
      });
      this.cancelButtons.forEach((btn) =>
        btn.addEventListener("click", () => {
          _this.removeAttribute("open");
          resolve(false);
          document.body.classList.remove("overflow-hidden");
        })
      );
    });
  }
}
customElements.define("confirm-modal", ConfirmModal);
